// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumbs_root__2O4ys","divider":"breadcrumbs_divider__5fYnN","segment":"breadcrumbs_segment__3vhV8"};